import { render, staticRenderFns } from "./AllCancelledAssessmentCandidates.vue?vue&type=template&id=133ac9f0&scoped=true"
import script from "./AllCancelledAssessmentCandidates.vue?vue&type=script&lang=ts"
export * from "./AllCancelledAssessmentCandidates.vue?vue&type=script&lang=ts"
import style0 from "./AllCancelledAssessmentCandidates.vue?vue&type=style&index=0&id=133ac9f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133ac9f0",
  null
  
)

export default component.exports